import { TableFilterButtons, TableFilterCard, TableFilterSection } from '@repo/ui/Table';
import { TextInputField } from '@repo/ui/Form';
import { registerInput } from '@repo/hooks/useZodForm';
import { useZodFormContext } from '@repo/hooks/useZodFormContext';

import React from 'react';
import { useFormState } from 'react-hook-form';
import type { Mercury } from '@repo/types/Models';

interface ConversationFilterProps {
  queryList: Mercury.Queries.QueryList;
}

const ConversationFilter = ({ queryList }: ConversationFilterProps) => {
  const filter = useZodFormContext();
  useFormState();
  if (!filter) {
    return <></>;
  }
  return (
    <TableFilterCard>
      <TableFilterSection>
        <TextInputField label="Remote Number" {...registerInput(filter, 'remote_number')} />
      </TableFilterSection>

      <TableFilterButtons className="self-end" />
    </TableFilterCard>
  );
};

export default ConversationFilter;
